/*eslint-disable*/
import React, { useEffect, useContext, useState } from "react";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

import { AppContext } from "../../AppContext";
import AuthService from "../../AuthService";

import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";

const styles = {
  formControl: {
    margin: "5px",
    width: "auto",
  },
  textfield: {
    margin: "10px 10px 10px 0px",
    width: "600px"
  },
  acceptButton: {
    background: "#87ceeb",
    color: "white",
    minWidth: "100px",
  },
};

const useStyles = makeStyles(styles);

export default function Notifications() {
  const context = useContext(AppContext);
  const classes = useStyles();

  const [templates, setTemplates] = React.useState([]);
  const [mailingLists, setMailingLists] = React.useState([]);
  const [selectedTemplate, setSelectedTemplate] = React.useState("");
  const [selectedMailingList, setSelectedMailingList] = React.useState("");
  const [subject, setSubject] = React.useState("");

  useEffect(() => {
    const authService = new AuthService();

    authService.setUrl(context.apiUrl + context.mailPath + "templates");
    authService.request("get", { }, (response) => {
      const { data } = response;
      console.log("data", data);
      if (data && data.length > 0) {
        setTemplates(data);
        setSelectedTemplate(data[0]);
      } else {
        console.log("No templates found !");
      }
    });

    authService.setUrl(context.apiUrl + context.mailPath + "mailingLists");
    authService.request("get", { }, (response) => {
      const { data } = response;
      console.log("data", data);
      if (data && data.length > 0) {
        setMailingLists(data);
        setSelectedMailingList(data[0]);
      } else {
        console.log("No mailing list found !");
      }
    });
  }, []);

  const startCampaign = () => {
    const authService = new AuthService();

    authService.setUrl(context.apiUrl + context.mailPath + "campaign");

    if (!subject) {
      alert("Subject is missing !");
      return;
    }

    let data = {
      subject,
      template: selectedTemplate.name,
      mailingList: selectedMailingList.address
    }
    console.log("data", data);

    authService.request("post", data, (response) => {
      console.log("response", response);
      alert(response.data.message);
    });
  }

  const handleTemplateChange = (event) => {
    setSelectedTemplate(event.target.value);
  }

  const handleMailingListChange = (event) => {
    setSelectedMailingList(event.target.value);
  }

  const handleSubjectChange = (event) => {
    setSubject(event.target.value);
  }

  return (
   <>
      <Card>
        <CardBody>
          <Typography variant="h6" sx={{ padding: '10px', textAlign: 'left' }}>
            Template
          </Typography>

          <FormControl className={classes.formControl}>
            <Select onChange={handleTemplateChange} value={selectedTemplate}>
              {templates.map((template) => (
                <MenuItem key={template.name} value={template}>
                  {template.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <p><b>Description</b> : {selectedTemplate.description}</p>
        </CardBody>
      </Card>

      <Card>
        <CardBody>
          <Typography variant="h6" sx={{ padding: '10px', textAlign: 'left' }}>
            Mailing list
          </Typography>

          <FormControl className={classes.formControl}>
            <Select onChange={handleMailingListChange} value={selectedMailingList}>
              {mailingLists.map((mailingList) => (
                <MenuItem key={mailingList.address} value={mailingList}>
                  {mailingList.address}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <p><b>Description</b> : {selectedMailingList.description}</p>
          <p><b>Members count</b> : {selectedMailingList.members_count}</p>
        </CardBody>
      </Card>

      <Card>
        <CardBody>
          <Typography variant="h6" sx={{ padding: '10px', textAlign: 'left' }}>
            Subject
          </Typography>

          <FormControl className={classes.formControl}>
            <TextField
              className={classes.textfield}
              value={subject}
              label="Subject"
              type="search"
              variant="outlined"
              onChange={handleSubjectChange}
            />
          </FormControl>
        </CardBody>
      </Card>

      <Button
        className={classes.acceptButton}
        onClick={() => startCampaign()}
        variant="contained"
      >
        Send campaign
      </Button>
   </>
  );
}
